import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {RegisterButtonBox} from "./boxes/register-button.box";
import {CyClass} from "../../../../../common/cy-classes";
import React from "react";
import {getButtonSizeVariant} from "../../welcome-buttons/header-welcome-buttons-helpers";
import {HeaderWelcomeButtonsAnalyticsSender} from "../../welcome-buttons/header-welcome-buttons-analytics-sender";
import {HeaderWelcomeRegisterButtonComponentProps} from "./header-register-button.component.props";


@observer
export class HeaderRegisterButtonComponent extends OrbitComponent<HeaderWelcomeRegisterButtonComponentProps> {
    private _onClick = async () => {
        new HeaderWelcomeButtonsAnalyticsSender('Register', this.services, this.props.gameContext).sendAnalytics();
        await this.services.externalLinks.openMembership( {
            marketingParams: {dl: "19518"}
        });
    }
    render() {
        if(this.services.cmsSegmentation.isCisOrCip || !this.services.configuration.data.generalSettings.showRegisterButton) {
            return null;
        }
        return (
            <RegisterButtonBox preset={this.props.preset ?? "primary"}
                               sizeVariant={getButtonSizeVariant(this.services)}
                               onClick={this._onClick}
                               className={CyClass("cy-register-button")}>

                {
                    this.props.text ?? this.services.translation.translate("SIGN_UP")
                }
            </RegisterButtonBox>
        );
    }
}